import ApiService from "./api.service";
const Documents = {
  add: async function (bodyFormData, id = false) {
    return ApiService.customRequest({
      method: 'post',
      url: `/documents${id ? `/${id}` : ''}`,
      data: bodyFormData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

  },
  get: async function () {
    //construction_id
    let response = await ApiService.get("/documents");
    return response.data.documents;
  },
  remove: async function (id) {
    await ApiService.delete("/documents/" + id);
    return true;
  },
  download: async function (id, filename) {
    ApiService.customRequest({
      url: `/documents/${id}`,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.target = "_blank";
      link.setAttribute('download', filename); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
  }
};

export default Documents;